// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hint-read-more p {\n  color: black;\n  font-size: 14px;\n  font-family: Roboto, serif;\n  font-weight: 400;\n  margin-left: 0;\n  margin-right: 0;\n  margin-top: 0;\n  margin-bottom: 0;\n}\n.hint-read-more p.margin-bottom {\n  margin-bottom: 10px;\n}\n.hint-read-more a {\n  color: #D99C15;\n  cursor: pointer;\n}\n.hint-read-more a:hover {\n  text-decoration: underline;\n}", ""]);
// Exports
module.exports = exports;
